/**
 * Converts address.line string values to single-element arrays
 */
const normalizeAddressLines = (organization) => {
  if (organization?.address && Array.isArray(organization?.address)) {
    return {
      ...organization,
      address: organization?.address?.map((addr) => {
        if (addr?.line && typeof addr?.line === "string") {
          return {
            ...addr,
            line: [addr.line],
          };
        }
        return addr;
      }),
    };
  }
  return organization;
};

/**
 * Normalizes type.coding to ensure proper FHIR structure
 * Converts legacy format {code, display} to {coding: [{code, display}]}
 */
const normalizeOrganizationType = (organization) => {
  if (organization.type && Array.isArray(organization.type)) {
    return {
      ...organization,
      type: organization?.type?.map((typeItem) => {
        // If coding already exists and is valid, return as-is
        if (typeItem?.coding && Array.isArray(typeItem?.coding)) {
          return typeItem;
        }

        // If coding is missing but code/display exist, create proper structure
        if (typeItem?.code || typeItem?.display) {
          return {
            coding: [
              {
                system: "http://hl7.org/fhir/ValueSet/organization-type",
                code: typeItem?.code,
                display: typeItem?.display,
              },
            ],
            text: typeItem?.display || typeItem?.text,
          };
        }

        // If neither coding nor code exists, create empty coding array
        return {
          ...typeItem,
          coding: [],
        };
      }),
    };
  }
  return organization;
};

/**
 * Applies all backwards compatibility transformations to organization data
 * This ensures data conforms to the expected schema before API calls
 */
export const handleBackwardsCompatibility = (organization) => {
  let normalizedOrganization = organization;
  normalizedOrganization = normalizeAddressLines(normalizedOrganization);
  normalizedOrganization = normalizeOrganizationType(normalizedOrganization);
  return normalizedOrganization;
};
